import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type UserInfo = {
  userId: string;
  email: string;
  hasFillInCode: number;
  inviteCode: string;
  membership: {
    expiryTime?: string;
    level?: string;
    status?: string;
  };
  steamToken: string;
  userIcon: string;
  userName: string;
  userUuid: string;
};

interface userInfoState {
  userInfo: UserInfo;
  setUserInfo: (value: object) => void;
  getUserInfo: () => UserInfo;
  removeUserInfo: () => void;
}

const initialValue = {
  userId: "",
  email: "",
  hasFillInCode: 1,
  inviteCode: "",
  membership: {
    expiryTime: "",
    level: "",
    status: "",
  },
  steamToken: "",
  userIcon: "",
  userName: "",
  userUuid: "",
};

const userInfoStore = create<userInfoState>()(
  persist(
    (set, get) => ({
      userInfo: initialValue,
      setUserInfo: (value: Partial<UserInfo>) => {
        set({ userInfo: { ...get().userInfo, ...value } });
      },
      getUserInfo: () => get().userInfo,
      removeUserInfo: () => set({ userInfo: initialValue }),
    }),
    {
      name: "userInfo",
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);

export default userInfoStore;
